import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStamp } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

export const NoSigSyncNotaryAssigned = () => {
  return (
    <div className={'flex flex-col justify-center'}>
      <section className={'flex flex-col justify-center gap-2'}>
        <div className={'flex justify-center'}>
          <FontAwesomeIcon className="w-12 h-12 text-extension-foundation-primary-variant" icon={faStamp} />
        </div>
        <div className={'flex justify-center'}>
          <span className="text-black font-medium">No Notary Assigned</span>
        </div>
      </section>
    </div>
  );
};
